import { get } from 'lodash';
import { logger } from '../../utils';
import { NextRouter } from 'next/router';
import { ComponentType } from '../components/widget/models/propertiesModels';

interface Action {
  label: string;
  onClick: (widgetId?: string) => void;
}

export enum ActionType {
  EDIT = 'edit',
  DELETE = 'delete',
  ADD_FILTER = 'addFilter',
  DUPLICATE = 'duplicate',
  ADD_WIDGET = 'addWidget',
  ADD_DASHLET = 'addDashlet',
  NEW = 'new',
}

export type ActionsRegistryType = {
  [key: string]: Action;
};

export const getActionsRegistry = (router: NextRouter): ActionsRegistryType => {
  const DASHBOARD_NAME = get(router, 'query.dashboardName[0]');
  const BASE_PATH = router.basePath;

  const pushRoute = (path: string) => {
    const fullPath = `/${router.query.appName}/${DASHBOARD_NAME}/${path}`;
    logger.log(`ActionsRegistry push route: ${BASE_PATH}${fullPath}`);
    router.replace(fullPath);
  };

  return {
    [ActionType.EDIT]: {
      label: 'Edit',
      onClick: (widgetId?: string) => pushRoute(`edit/${widgetId}`),
    },
    [ActionType.DELETE]: {
      label: 'Delete',
      onClick: (widgetId?: string) => pushRoute(`delete/${widgetId}`),
    },
    [ActionType.ADD_FILTER]: {
      label: 'Add Filter',
      onClick: () => pushRoute(`new/${ComponentType.FILTER}`),
    },
    [ActionType.ADD_WIDGET]: {
      label: 'Add Widget',
      onClick: () => pushRoute(`new/${ComponentType.WIDGET}`),
    },
    [ActionType.ADD_DASHLET]: {
      label: 'Add Dashlet',
      onClick: () => pushRoute(`new/${ComponentType.DASHLET}`),
    },
    [ActionType.DUPLICATE]: {
      label: 'Duplicate',
      onClick: (widgetId?: string) => pushRoute(`${ActionType.DUPLICATE}/${widgetId}`),
    },
  };
};
